const configuredApiBase = import.meta.env.VITE_URBANIK_API_URL?.replace(/\/$/, '');

export const apiBase = configuredApiBase ?? window.location.origin;
// Dedicated fixture backend; never fall back to the operational API override.
export const reviewApiBase =
  import.meta.env.VITE_URBANIK_REVIEW_API_URL?.replace(/\/$/, '') ?? window.location.origin;
